import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@emotion/react";
import { Router } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga4";

import reportWebVitals from "./reportWebVitals";

import App from "./App";
import { createClient } from "./lib/apollo";
import { theme } from "./theme";

import "./index.css";

const history = createBrowserHistory();
ReactGA.initialize("G-Y8729YT7D5", /* {gaOptions: {userId: }} */);
history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.send({ hitType: "pageview", page: location.pathname});
});

const client = createClient();

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Router>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
